// extracted by css-extract-rspack-plugin
export default {"header":"beVbPn"};